import { ArrowRight } from 'iconsax-react'
import { useTranslation } from 'react-i18next'

import { formatDate } from '@/utils/date'
import { weCheckPalette } from '@/utils/palette/weCheckPalette'

interface FollowUpWidgetProps {
  updatedAt: string
  sinceDate: string
}

export const FollowUpWidget = ({
  updatedAt,
  sinceDate,
}: FollowUpWidgetProps) => {
  const { t } = useTranslation()
  return (
    <div className="flex items-center p-2 gap-3">
      <p className="text-neutralColor60 text-sm font-medium">
        {t('dashboard.reportGeneralInfo.since')}{' '}
        {formatDate(sinceDate, 'MM/dd/yyyy')}
      </p>
      <ArrowRight size="24" color={weCheckPalette.neutralColor60} />
      <p className="text-neutralColor text-sm font-medium">
        {t('dashboard.reportGeneralInfo.updated')}{' '}
        {formatDate(updatedAt, 'MM/dd/yyyy')}
      </p>
    </div>
  )
}
